export default __webpack_public_path__ + "assets/fr-CA.f2e0a5a70c042746112bcf415054305a.svg";